// Preserve scroll position while locking body scroll.
// Uses a lock count so nested / sequential SlideIns (e.g. Shop the Look → Bag)
// don't unlock the page while another panel is still open.
const $body = document.querySelector("body");
let scrollPosition = 0;
let locks = 0;

export default {
  enable() {
    if (locks === 0) {
      scrollPosition = window.pageYOffset;
      $body.style.overflow = "hidden";
      $body.style.position = "fixed";
      $body.style.top = `-${scrollPosition}px`;
      $body.style.left = `0px`;
      $body.style.right = `0px`;
      $body.style.bottom = `0px`;
      $body.style.width = "100%";
    }
    locks += 1;
  },
  disable() {
    if (locks === 0) {
      return;
    }

    locks -= 1;

    if (locks > 0) {
      return;
    }

    $body.style.removeProperty("overflow");
    $body.style.removeProperty("position");
    $body.style.removeProperty("top");
    $body.style.removeProperty("left");
    $body.style.removeProperty("right");
    $body.style.removeProperty("width");
    $body.style.removeProperty("bottom");
    window.scrollTo(0, scrollPosition);
  },
};
